import React from 'react';
import './style.scss'; 

export interface UQStatisticCardProps {
  label: string;
  value: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  size?: 's' | 'm' | 'l'; 
}

const UQStatisticCard: React.FC<UQStatisticCardProps> = ({
  label,
  value,
  className = '',
  style,
  size = 's', 
}) => (
  <div className={`uq-statistic-card uq-statistic-card-${size} ${className}`} style={style}>
    <div className="uq-statistic-label">{label}</div>
    <div className="uq-statistic-value">{value}</div>
  </div>
);

export default UQStatisticCard;